import styled from 'styled-components'

import { Container as Card } from '../../components/Card/styles'
import bgImage from '../../assets/images/login-bg.jpg'

export const Container = styled.div`
	padding: 8vh 0;
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 360px 1fr;
	justify-content: center;
	background-image: url(${bgImage});
  	background-position: bottom;
	background-size: cover;
	background-repeat: no-repeat;

	@media(max-width: 1050px) {
		padding: 2vh 0;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
`

export const Content = styled(Card).attrs({
    className: 'no-responsive'
})`
	grid-column: 2;
	width: 100%;
	max-width: 315px;
	text-align: center;
	justify-self: center;
	height: fit-content;

	img {
		margin: auto;
	}

	form {
		display: flex;
		flex-direction: column;

		h1 {
			font-size: 18px;
			margin: 0 8px 0;
			font-weight: 500;
		}

		p {
			padding: 15px;
		}

		a {
			font-size: 14px;
			opacity: 0.8;
			line-height: 29px;

			&:hover {
				opacity: 1;
				text-decoration: underline;
			}
		}

		button {
			margin: 15px 8px 0 !important;

		}
	}
`

export const LoginsContainer = styled(Card)`
	max-width: 350px;
	justify-self: flex-end;
`
